var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessageTailLeft = function SvgMessageTailLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.126.115h24.563c0 12.638-10.245 22.883-22.883 22.883H0v-.538a22.882 22.882 0 0 0 5.679-7.139c1.834-3.6 2.32-8.02 2.448-15.206Z",
    fill: "currentColor"
  })));
};
export { SvgMessageTailLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzMgMjMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC4xMjU1NyAwLjExNTIzNEgzMi42ODg1QzMyLjY4ODUgMTIuNzUyOCAyMi40NDM3IDIyLjk5NzYgOS44MDYxNCAyMi45OTc2SC0wLjAwMDU5ODkwN1YyMi40NjAzQzIuMzM4NzggMjAuNDk2OSA0LjI3NTIyIDE4LjA3MzUgNS42Nzc2NCAxNS4zMjExQzcuNTEyMjQgMTEuNzIwNSA3Ljk5NzMxIDcuMzAxMzIgOC4xMjU1NyAwLjExNTIzNFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";